import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api/client'
import type { TaskContext } from '../types'

/**
 * The task with whatever its module can say about it.
 *
 * One call, not two. A screen that renders the request while the supporting detail is still
 * loading is a screen people approve from — which is exactly what the regularisation slice
 * found, and why this endpoint exists at all.
 */
export function useTaskContext(taskId: string | null) {
  return useQuery({
    queryKey: ['approvals', 'tasks', taskId, 'context'],
    enabled: taskId != null,
    queryFn: async () =>
      (await apiClient.get<TaskContext>(`/v1/approvals/tasks/${taskId}/context`)).data,
  })
}
